import React, { useState } from 'react';
import { Button, Spinner } from 'reactstrap';

const SubmitButton = ({ isLoading, children, ...props }) => {
  return (
    <Button {...props} disabled={isLoading}>
      {isLoading ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
          <span className="ml-2">Submitting...</span>
        </>
      ) : (
        children
      )}
    </Button>
  );
};

export default SubmitButton;